import React, { useState } from 'react';

export default function CollapsibleSection({ title, children, defaultOpen = true, iconClass, headerActions = null }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="min-w-0 bg-white border border-slate-200 rounded-xl">
      <div className="w-full px-3 sm:px-4 pt-3 pb-2 flex items-start sm:items-center justify-between gap-3">
        <span className="text-sm font-semibold text-slate-700 flex items-center gap-2 sm:gap-3 min-w-0">
          {iconClass ? (
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-slate-100 border border-slate-100">
              <i className={`${iconClass} text-lg text-slate-600`} />
            </span>
          ) : null}
          <span className="min-w-0 break-words sm:truncate">{title}</span>
        </span>
        <div className="flex items-center gap-2 shrink-0">
          {headerActions}
          <button
            type="button"
            className="text-slate-400 hover:text-slate-600 cursor-pointer"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? 'Collapse section' : 'Expand section'}
          >
            <i className={open ? 'ri-arrow-up-s-line text-base' : 'ri-arrow-down-s-line text-base'} />
          </button>
        </div>
      </div>
      <div
        className={`px-3 sm:px-4 pb-3 min-w-0 ${open ? '' : 'hidden'}`}
        aria-hidden={!open}
      >
        {children}
      </div>
    </section>
  );
}

